"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartialPayment = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Field_1 = require("../../Form/Field");
const MoneyLabel_1 = require("../MoneyLabel");
require("./index.scss");
const className = 'partial-payment';
const Remaining = (props) => {
    const { value } = props;
    if (value === undefined)
        return null;
    return (react_1.default.createElement("div", { className: `${className}__remaining` },
        react_1.default.createElement(MoneyLabel_1.PaymentMoneyLabel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Payment/PartialPayment:remaining', defaultMessage: 'Remaining:' }), price: value })));
};
const PartialPayment = (props) => {
    const { nativeValue, onChange, remaining, hidden, disabled, error } = props;
    if (hidden)
        return null;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__field` },
            react_1.default.createElement(Field_1.FormFieldStable, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Payment/PartialPayment:label', defaultMessage: 'Partial payment' }), addon: 'CHF', nativeValue: nativeValue, onChange: onChange, disabled: disabled, error: error })),
        react_1.default.createElement(Remaining, { value: remaining })));
};
exports.PartialPayment = PartialPayment;
//# sourceMappingURL=index.js.map